export default __webpack_public_path__ + "static/media/Flag_of_Rwanda.3c6f00ea.svg";